import React from "react"
import PictureDom from './picture_dom';

const BuildImageDiv = (props) => {
    let divTemplate={}
    let coverImage = props.coverImage;
    var isAlbumCover = coverImage.indexOf(props.thumbnailEncryption) >= 0
    divTemplate.id=props.assetId+"po_sav";     
    
    divTemplate.className=' selectable-asset';
    //If photo title is empty then show empty message with counter otherwise show photo title.
    var ariaLabel = (props.caption.pictTitle == photoOrg.translations.photos["no_title_friends_albums"]) ?
        photoOrg.translations.photos["aria_label"]["photo_with_notitle"]+" "+props.noTitlePhotosCount++ : props.caption.pictTitle;
        divTemplate['aria-label']=ariaLabel;
        divTemplate.tabIndex = 0;
    if (isAlbumCover) {
        divTemplate.className+=" album-cover";
    }
    //calculate proportinate value of  width, using height
    const height = 200;
    let width = 200
    try{
        //adjusted width = <user-chosen height> * original width / original height
        width = 200 * props.width / props.height;
    }catch (e){
    width =200;
    }

    divTemplate.className.replace(/selected/g, '');
    divTemplate["data-width"]=width;
    divTemplate["data-height"]=height;

    if(props.showTitle){
        divTemplate.className += " asset_caption"
        divTemplate.style = {transition: 'margin 0.8s linear'}
    }
    return (
        <div {...divTemplate} aria-label={divTemplate['aria-label']} >
            <PictureDom {...props} />
        </div>
    );        
}

export default BuildImageDiv;